import axios from '@/utils/request'
var Qs = require('qs')

export default {
  productMixStates: ['mixing', 'mixed', 'unMix'],
  // 2020-08-08
  search(params) {
    return axios.get('/products?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2020-08-10
  delete(id) {
    return axios.delete('/products/' + id)
  },
  // 2021-04-13
  batchDelete(params) {
    return axios.put('/products/batch-delete', params)
  },
  // 2020-08-10
  refresh(id) {
    return axios.put('/products/' + id + '/refresh')
  },
  // 2020-08-17
  findByUuid(params) {
    return axios.get('/products/find-by-uuid', params)
  },
  // 2020-08-25
  create(params) {
    return axios.post('/products', params)
  },
  // 2020-08-25
  update(id, params) {
    return axios.put('/products/' + id, params)
  },
  // 2021-05-21
  updateYshopInfo(id, params) {
    return axios.put('/products/' + id + '/update-yshop-info', params)
  },
  // 2021-05-21
  batchShow(params) {
    return axios.put('/products/batch-show', params)
  },
  // 2021-05-21
  batchCancelShow(params) {
    return axios.put('/products/batch-cancel-show', params)
  },
  // 2021-05-21
  batchUpdateSerial(params) {
    return axios.put('/products/batch-update-serial ', params)
  },
  // 2020-08-18
  verifyBatch(params) {
    return axios.put('/products/verify-batch', params)
  },
  // 2020-08-18
  asyncImageToOrder(id, params) {
    return axios.put('/products/' + id + '/async-image-to-order', params)
  },
  // 2020-02-26
  asyncImageToInv(id) {
    return axios.put('/products/' + id + '/async-image-to-inv')
  },
  // 2020-08-20
  vagueFindByProductNo(params) {
    return axios.get('/products/vague-find-by-product-no', params)
  },
  // 2021-02-03
  vagueFindByProductNoAll(params) {
    return axios.get('/products/vague-find-by-product-no-all', params)
  },
  // 2020-08-22
  findByProductNo(params) {
    return axios.get('/products/find-by-product-no', params)
  },
  // 2020-08-25
  batchInsertLabels(params) {
    return axios.post('/products/insert-batch-labels', params)
  },
  // 2020-08-25
  exportExcel(params) {
    return axios.get('/products/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2021-06-22
  exportExcelPhases(params) {
    return axios.get('/products/export-excel-phases?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2020-08-28
  privatize(quotationId, params) {
    return axios.post('/products/privatize/' + quotationId, params)
  },
  // // 02-03
  // count() {
  //   return axios.get('/products/count')
  // },
  // 2020-08-31
  unQuoted(params) {
    return axios.get('/products/un-quoted', params)
  },

  //======================
  // 2020-08-18
  productSuppliersfindById(id) {
    return axios.get('/products/' + id + '/suppliers')
  },
  // 2020-08-18
  createProductSupplier(params) {
    return axios.post('/products/suppliers/insert-batch', params)
  },
  // 2020-08-18
  updateProductSupplier(productsSupplierId, params) {
    return axios.put('/products/suppliers/' + productsSupplierId, params)
  },
  // 2020-08-18
  deleteProductSupplier(productsSupplierId) {
    return axios.delete('/products/suppliers/' + productsSupplierId)
  },
  // 2020-08-18
  updateDefaultSupplier(productsSupplierId) {
    return axios.put('/products/suppliers/' + productsSupplierId + '/update-default-supplier')
  },
  // 2020-10-31
  suppliersFindByProductNo(params) {
    return axios.get('/products/suppliers/find-by-product-no', params)
  },
  // 2020-08-21
  mix(id) {
    return axios.put('/products/' + id + '/mix')
  },
  // 2020-08-22
  finishMix(id) {
    return axios.put('/products/' + id + '/finish-mix')
  },
  // 2021-04-29
  updateCraftwork(id, params) {
    return axios.put('/products/' + id + '/update-craftwork', params)
  },

  // 2021-07-08
  copy(id, params) {
    return axios.put('/products/' + id + '/copy', params)
  },
  // 2021-12-10
  batchUpdateSupplierPriceToCost(params) {
    return axios.put('/products/batch-update-supplier-price-to-cost', params)
  },
  //======================
  // 2020-08-19
  productPhases(id) {
    return axios.get('/mes/products/' + id + '/phases')
  },
  // 2020-08-19
  cteatePhases(params) {
    return axios.post('/mes/products/phases', params)
  },
  // 2020-08-19
  updatePhase(phaseId, params) {
    return axios.put('/mes/products/phases/' + phaseId, params)
  },
  // 2020-08-19
  deletePhase(phaseId) {
    return axios.delete('/mes/products/phases/' + phaseId)
  },
  // 2021-01-11
  swapSequence(params) {
    return axios.put('/mes/products/phases/swap-sequence', params)
  },
  // 2020-08-19
  exportExcelPhasesById(id) {
    return axios.get('/mes/products/' + id + '/phases/export-excel')
  },
  // 2021-02-01
  exportExcelForEditPhases(id) {
    return axios.get('/mes/products/' + id + '/phases/export-excel-for-edit')
  },
  // 2021-07-01
  calcCostMes(id) {
    return axios.get('/mes/products/' + id + '/phases/calc-cost')
  },
  // 2021-09-10
  calcTotalPeriod(id) {
    return axios.get('/mes/products/' + id + '/phases/calc-total-period')
  },
  //======================
  // 2020-08-20
  boms(id) {
    return axios.get('/mms/products/' + id + '/boms')
  },
  // 2021-02-10
  bomsFindByProductInfoWithQty(id, params) {
    return axios.get('/mms/products/' + id + '/boms/find-by-product-info-with-qty', params)
  },
  // 2020-08-21
  ingredient(params) {
    return axios.post('/mms/products/ingredient', params)
  },
  // //
  // createBom(id, params) {
  //   return axios.post('/mms/products/' + id + '/boms', params)
  // },
  // 2020-08-20
  updateBom(id, bomId, params) {
    return axios.put('/mms/products/' + id + '/boms/' + bomId, params)
  },
  // 2020-08-20
  deleteBom(id, bomId) {
    return axios.delete('/mms/products/' + id + '/boms/' + bomId)
  },

  // 2020-08-20
  exportExcelBoms(id) {
    return axios.get('/mms/products/' + id + '/boms/export-excel')
  },
  // 2021-02-01
  exportExcelForEditBoms(id) {
    return axios.get('/mms/products/' + id + '/boms/export-excel-for-edit')
  },
  // 2021-01-30
  asyncPriceToOther(id, params) {
    return axios.put('/products/' + id + '/async-price-to-other', params)
  },

  // 2023-06-05
  syncCostPriceToMes(id, params) {
    return axios.put('/products/' + id + '/sync-cost-price-to-mes', params)
  },
  // 2021-04-19
  addNoMaterialBom(id, params) {
    return axios.put('/mms/products/' + id + '/add-no-material-bom', params)
  },
  // 2021-07-01
  calcCostMms(id) {
    return axios.get('/mms/products/' + id + '/boms/calc-cost')
  },
  // 2021-12-30
  calcMatierlsByProductInfo(params) {
    return axios.put('/mms/products/boms/calc-matierls-by-product-info', params)
  },
  // // 2022-01-17
  // calcMatierlsByOrder(params) {
  //   return axios.put('/mms/products/boms/calc-matierls-by-order', params)
  // },

  // 2022-01-19
  batchFindBomByProductInfo(params) {
    return axios.put('/mms/products/boms/batch-find-bom-by-product-info', params)
  },
  // 2021-05-24
  repeatCount() {
    return axios.get('/products/repeat-count')
  },
}

